<tilby-dialog-toolbar
    [title]="'DASHBOARD.DIALOG.TITLE'"
    [customActions]="customActions"
    [hideConfirm]="true"
/>
<tilby-dialog-content class="tw-p-0">
    <app-fiscal-grid [rowData]="data.alignedPrinters ?? []"></app-fiscal-grid>
</tilby-dialog-content>
